module.exports = __webpack_public_path__ + "img/sign-left-bg.968ad661.png";